<template>
    <section class="featured-categories-wrap mt-4">
        <div class="container">
            <FeaturedGridSkeleton :quantity="20" v-if="!isFetchingFeaturedCategories"></FeaturedGridSkeleton>
            <div v-else>
                <div class="featured-categories-header mb-2">
                    <h2 class="section-title">{{ data.title }}</h2>
                </div>
                <div class="featured-categories" ref="featuredCategories">
                    <div class="category-item" v-for="(category, index) in data.categories">
                        <a :href="route('categories.products.index', category.slug)" class="featured-category-image">
                            <div class="square-image-wrapper">
                                <img width="130" :src="category.logo.path" :class="{ 'image-placeholder': !category.logo.path }" alt="category logo">
                                <span class="featured-category-name">{{ category.name }}</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ProductCard from '../ProductCard.vue';
import FeaturedGridSkeleton from './SkeletonLoader/FeaturedGridSkeleton.vue';

export default {
    components: { ProductCard, FeaturedGridSkeleton },
    data() {
        return {
            data: [],
            isFetchingFeaturedCategories: false,
        };
    },

    mixins: [
    ],

    props: [],

    created() {
        $.ajax({
            method: 'GET',
            url: route('ecommerce.home.featured_categories.index'),
        }).then((response) => {
            this.data = response;

            this.isFetchingFeaturedCategories = true;

            this.$nextTick(() => {
                $(this.$refs.featuredCategories).slick(this.slickOptions());
            });
        }).catch((xhr) => {
            this.fetchingProductsByCategory = false;
            this.$notify(xhr.responseJSON.message);
        });
    },

    methods: {
        slickOptions() {
            return {
                rows: 2,
                dots: false,
                arrows: true,
                infinite: false,
                slidesToShow: 8,
                slidesToScroll: 8,
                rtl: window.FleetCart.rtl,
                responsive: [
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 8,
                            slidesToScroll: 8,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 6,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToShow: 3.6,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            arrows: false,
                            slidesToShow: 2.7,
                            slidesToScroll: 2,
                        },
                    },
                ],
            };
        },
    },

};
</script>
